import React, { FC } from 'react'

import { Asset } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { isImage as checkIsImage, colorsByExtension } from '@avantstay/backoffice-core'

import { IconAsset } from '@avantstay/backoffice-vectors'
import { FilePreviewType } from '@new/__ui/UploadArea/_types'

import * as Preview from '../../FilePreview/FilePreview.styles'

interface FilePreviewReadModeProps {
  file: Asset
  filePreviewType?: FilePreviewType
}

export const FilePreviewReadMode: FC<FilePreviewReadModeProps> = ({ file, filePreviewType }) => {
  const extension = ((file.fileName || '').split('.').pop() ?? '').toUpperCase()
  const isImage = checkIsImage(extension)

  return (
    <Preview.FilePreviewContainer
      onClick={() => window.open(file.url)}
      filePreviewType={filePreviewType}
    >
      {isImage ? (
        <Preview.ImagePlaceholder>
          <Preview.Image src={file.url} />
        </Preview.ImagePlaceholder>
      ) : (
        <Preview.FileContainer>
          <IconAsset />
          <Preview.Extension background={colorsByExtension[extension]?.background}>
            {extension}
          </Preview.Extension>
        </Preview.FileContainer>
      )}
    </Preview.FilePreviewContainer>
  )
}
